import React, {useEffect, useState} from "react";
import {ResultCardList} from "./ResultCardList";
import {ResultNamedCard} from "./ResultNamedCard";
import {MultipleAnimation} from "Animations";
import {CardsWrapper} from "./ResultCard.styles";
import {CardsWrapper as CardsWrapperList} from "./ResultCardList.styles";

import _ from "lodash";

export const ResultCards = ({markersData, margin, DirectionsLinkText, UseNewCardStyle}) => {
  const [manipulatedData, setManipulatedData] = useState([]);
  const [manipulatedLetterData, setManipulatedLetterData] = useState([]);
  const addLettersAndSort = () => {

    markersData = markersData.filter(c => c !== undefined && c !== '');
    if (!markersData?.length) {
      return;
    }

    const result = _(markersData)
      .groupBy(o => o.SortingName[0].toUpperCase())
      .map((markers, letter) => ({letter, markers}))
      .value();
    let sortedArrayLetter = result.sort((a, b) => {
      return a.letter.localeCompare(b.letter);
    });
    setManipulatedLetterData(sortedArrayLetter);

    let letterArray = [];
    markersData.map(({SortingName}) => {
      let firstLetter = SortingName.charAt(0);
      let objToAdd = {SortingName: firstLetter};
      if (!letterArray.some((letter) => letter.SortingName === firstLetter)) {
        letterArray.push(objToAdd);
      }
    });
    let sortedArray = letterArray.concat(markersData).sort((a, b) => {
      return a.SortingName.localeCompare(b.SortingName);
    });
    setManipulatedData(sortedArray);
  };

  useEffect(() => {
    addLettersAndSort();
  }, [markersData]);

  return (
    UseNewCardStyle ? <CardsWrapper smallmargin="0" margin="0 0 0 -1rem" smallrow flexwrap="wrap" useGrid={true}>
        <MultipleAnimation items={manipulatedLetterData} itemProp="marker">
          <ResultNamedCard/>
        </MultipleAnimation>
      </CardsWrapper> :
      <CardsWrapperList smallmargin="0" margin="0 0 0 -1rem" smallrow flexwrap="wrap">
        {manipulatedData?.length > 0 && manipulatedData?.map((marker, key) => (
          <ResultCardList
            marker={marker}
            DirectionsLinkText={DirectionsLinkText}
            key={`ResultCard-${key}`}
          />
        ))}
      </CardsWrapperList>
  );
};
